export interface StandardCrudErrors {
    ADD_MODEL_OBJECT: any;
    GET_MODEL_OBJECT: any;
    GET_MODEL_OBJECTS: any;
    UPDATE_MODEL_OBJECT: any;
    DELETE_MODEL_OBJECT: any;
}

export const initialStandardCrudErrorsState: StandardCrudErrors = {
    ADD_MODEL_OBJECT: null,
    GET_MODEL_OBJECT: null,
    GET_MODEL_OBJECTS: null,
    UPDATE_MODEL_OBJECT: null,
    DELETE_MODEL_OBJECT: null
};

